import { Dispatch, ReactElement, SetStateAction } from "react";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Dialog } from "@mui/material";

import {
  LogoImg,
  ModalTitle,
  ModalMessage,
  ModalFooter,
} from "./styles/DuplicateDocumentModalStyles";

import MarkLogo from "../../assets/images/MarkLogo.png";

import COLORS from "../../theme/Colors";
import ErrorIcon from "@mui/icons-material/Error";
interface Props {
  showDialogModal: boolean;
  setShowDialogModal: Dispatch<SetStateAction<boolean>>;
}

const DuplicateDocumentModal = ({
  showDialogModal,
  setShowDialogModal,
}: Props): ReactElement => {
  return (
    <Dialog open={showDialogModal}>
      <IconButton
        sx={{ alignSelf: "flex-end", padding: "16px" }}
        aria-label="close"
        onClick={() => setShowDialogModal(false)}
      >
        <CloseIcon sx={{ color: COLORS.primary }} />
      </IconButton>
      <div
        style={{
          justifyContent: "center",
          padding: "32px",
          paddingTop: 0,
          textAlign: "center",
        }}
      >
        <ErrorIcon fontSize="large" sx={{ color: COLORS.error, fontSize: "10rem" }} />
        <ModalTitle>¡Alerta! El ID de los participantes es idéntico</ModalTitle>
        <ModalMessage>
          ¡Atención golfista! El número de identificación que estás intentando
          registrar ya existe, por favor valide la identificación e intente de
          nuevo.
        </ModalMessage>
        <ModalFooter>
          ¡Gracias por su interés en formar parte de esta extraordinaria
          experiencia!
        </ModalFooter>
      </div>
    </Dialog>
  );
};
export default DuplicateDocumentModal;
